import TextField from "@material-ui/core/esm/TextField";
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { PrivilegeService } from 'api';
import { getPendingPrivilegesRequestId } from 'api/privileges/getCustomerPendingPrivileges';
import { PrimaryButton } from 'components/Button';
import InfoBox from 'components/InfoBox/InfoBox';
import { Title } from 'components/Text';
import { emailRegex } from 'constants/regex';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import useStyles from './AccessStyles';
export default function AddPrivilege() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const {
    newUserGrid,
    column,
    emailField
  } = useStyles();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const setPendingPrivilegeRequestId = useSetRecoilState(getPendingPrivilegesRequestId);
  const {
    enqueueSnackbar
  } = useSnackbar();
  const isValidEmail = emailRegex.test(email);
  const emailError = !!email && !isValidEmail;
  useEffect(() => {
    return () => {
      setEmail('');
    };
  }, []);
  const addPrivilege = async () => {
    setLoading(true);
    try {
      await PrivilegeService.grantPrivilege({
        body: {
          customerRef: customer?.id,
          receiverEmail: email
        }
      });
      enqueueSnackbar(t('access_management.activation_link_sent_successfully'), {
        variant: 'success'
      });
      setEmail('');
    } catch {
      enqueueSnackbar(t('access_management.send_activation_link_failed'), {
        variant: 'error'
      });
    }
    setPendingPrivilegeRequestId(id => id + 1);
    setLoading(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    isBold: true
  }, t('access_management.add_user')), /*#__PURE__*/React.createElement("div", {
    className: newUserGrid
  }, /*#__PURE__*/React.createElement("span", {
    className: column
  }, t('access_management.email_new_user'), ":"), /*#__PURE__*/React.createElement(TextField, {
    id: "add-user-email",
    placeholder: t('profile.email'),
    onChange: e => setEmail(e.target.value),
    value: email,
    error: emailError,
    helperText: emailError && t('validation.email_format'),
    variant: "outlined",
    className: clsx(column, emailField)
  }), /*#__PURE__*/React.createElement(PrimaryButton, {
    onClick: addPrivilege,
    loading: loading,
    disabled: !isValidEmail,
    className: column
  }, t('access_management.add_user_button'))), /*#__PURE__*/React.createElement(InfoBox, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "access_management.add_user_info"
  })));
}